import { get_el } from 'js/utils';

export default class Map_Dots {

    constructor(container, args = {}){
        this.args = args;
        this.container = get_el(container);

        window.addEventListener('resize', ()=>this.recalculate())

        this.dots = [];
    }

    recalculate(){

        clearTimeout(this.recalculate_debounce)

        this.recalculate_debounce = setTimeout(()=>{

            const dimensions = this.get_dimensions();

            this.dots.forEach(dot=>{
                dot.update_position(dimensions)
            })

        }, 300)
        
    }

    get_dimensions(){
        return {
            width: this.args.width,
            height: this.args.height,
            new_width: this.container.offsetWidth,
            new_height: this.container.offsetHeight,
        }
    }

    load(data, args = {}){

        if( typeof data === 'string' ) {
            data = JSON.parse(data);
        }
        
        const dimensions = this.get_dimensions();

        data.forEach(pos=>{
            
            const dot = this.create_dot(pos[0], pos[1]);
            dot.update_position(dimensions);
            
            if( typeof args.before_show === 'function' ) {
                args.before_show(dot.el);
            }
            
            if( args.dot_class ) {
                dot.el.classList.add(args.dot_class);
            }
        })

        const interval = args.interval ?? 80;

        setTimeout(()=>{
            this.dots.forEach((dot, i)=>{

                setTimeout(()=>{

                    // dot.el.style.transform = 'scale(1)';

                    if( typeof args.on_show === 'function' ) {
                        args.on_show(dot.el);
                    }
                    
                }, i * interval)
            })
        }, 10)
    }

    get_position(x, y, dimensions) {
        return {
            x: x * (dimensions.new_width / dimensions.width),
            y: y * (dimensions.new_height / dimensions.height)
        };
    }
    
    create_dot(x, y){

        const el = document.createElement('div')
        el.className = 'dot';
        
        this.container.append(el)
        
        const origin = { x, y }

        const dot = {
            el,
            x,
            y,
        }
        
        dot.update_position = (dimensions)=>{

            const x = origin.x * (dimensions.new_width / dimensions.width);
            const y = origin.y * (dimensions.new_width / dimensions.width);
            
            el.style.left = x + 'px';
            el.style.top = y + 'px';
        }
        
        this.dots.push(dot)
        
        return dot;
    }

}